import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { ResponsivePicture } from "../../../Shared/components/Image";
import { Link } from './library/link';
import { classNamesConfig } from '../../../Shared/features/classnames';
import { slugify } from '../../../Shared/utils/string';
export const Book = (p)=>{
    let content = (p)=>/*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "book__caption",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "book__header title--xs",
                            children: "Boekentip"
                        }),
                        /*#__PURE__*/ _jsx("h3", {
                            className: "book__title title--s",
                            children: /*#__PURE__*/ _jsx("span", {
                                children: p.title
                            })
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "book__text text--m",
                            children: /*#__PURE__*/ _jsx("span", {
                                children: p.author
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "book__visual",
                    children: /*#__PURE__*/ _jsx(ResponsivePicture, {
                        className: "book__image",
                        defaultImageUrl: p.imageUrlFallback,
                        cropsPerMedia: [
                            {
                                crops: [
                                    {
                                        url: p.imageUrl,
                                        width: 195
                                    },
                                    {
                                        url: p.imageUrlLarge,
                                        width: 380
                                    }
                                ]
                            }
                        ],
                        height: 195,
                        alt: p.imageAlt
                    })
                })
            ]
        });
    return /*#__PURE__*/ _jsx("article", {
        className: `book ${p.className && p.className}`,
        children: p.url ? /*#__PURE__*/ _jsx(Link, {
            url: p.url,
            className: "book__inner book__link",
            children: content(p)
        }) : /*#__PURE__*/ _jsx("div", {
            className: "book__inner",
            children: content(p)
        })
    });
};
export const BooksBlock = (p)=>{
    const className = classNamesConfig().books;
    return /*#__PURE__*/ _jsxs("aside", {
        className: `books ${className.block}`,
        children: [
            /*#__PURE__*/ _jsx("header", {
                className: "books__header",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: `${className.inner}`,
                    children: [
                        p.title && /*#__PURE__*/ _jsx("h2", {
                            "data-anchor": slugify(p.title),
                            className: "books__title container--xs title--m",
                            children: p.title
                        }),
                        p.text && /*#__PURE__*/ _jsx("p", {
                            className: "books__intro container--xs",
                            children: p.text
                        })
                    ]
                })
            }),
            !p.books.isEmpty() && /*#__PURE__*/ _jsx("div", {
                className: "books__list",
                children: /*#__PURE__*/ _jsx("div", {
                    className: `${className.inner}`,
                    children: /*#__PURE__*/ _jsx("ul", {
                        className: "books__list-inner",
                        children: p.books.map((book, k)=>/*#__PURE__*/ _jsx("li", {
                                className: "books__item",
                                children: /*#__PURE__*/ _jsx(Book, {
                                    ...book
                                })
                            }))
                    })
                })
            })
        ]
    });
};
{
/* TH: Added to styleguide! */ }